import { usePropertyRentalNumberUnits } from '../../../../../../queries/PropertyFields/RentalUnitsFields';
import { ApplicationQuestionReviewItem } from '../../../../../components/ApplicationQuestionReviewItem';
import { DropDownBox } from '@apply/components';

interface RentalUnitsDropDownProps {
    propertyGuid: string;
    isReview?: boolean;
}

export const RentalUnitsDropDown: React.FC<RentalUnitsDropDownProps> = ({ propertyGuid, isReview = false }) => {
    const label = 'Rental Units';
    const [numberRentalUnits, set_numberRentalUnits] = usePropertyRentalNumberUnits(propertyGuid);

    const numberUnitsValues = [
        { display: '', value: '' },
        ...[...Array.from(Array(31).keys())]
            .map((x) => x + 5)
            .map((count) => {
                return {
                    display: count.toString(),
                    value: count,
                };
            }),
    ];

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={numberRentalUnits}
                />
            ) : (
                <DropDownBox
                    id={'rentalUnitsDropdown'}
                    value={numberRentalUnits}
                    onChange={(value) => set_numberRentalUnits(value)}
                    label={label}
                    dataSource={numberUnitsValues}
                    valueExpr='value'
                    displayExpr='display'
                    required={true}
                />
            )}
        </>
    );
};
